module.exports = __webpack_public_path__ + "img/ico-edit.357f30f7.svg";